import React, { useContext, useState, useEffect } from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { getShopifyImage } from 'gatsby-source-shopify';
import styled from 'styled-components';
import { fontWeights, fontSize } from '../styles';
import { QuantityInput } from './ui';
import { formatPrice } from '../utils';
import { StoreContext } from '../context/StoreContext';

const StyledCartItem = styled.div`
  display: grid;
  grid-template-columns: 70px 1fr;
  gap: 15px;
`;

const StyledDetails = styled.div`
  grid-column: 2/3;
`;

const StyledNamePrice = styled.div`
  display: flex;
  justify-content: space-between;
`;

const StyledName = styled.h4`
  font-weight: ${fontWeights.regular};
  ${fontSize(16)};
`;

const StyledPrice = styled.p`
  margin-left: 15px;
`;

const StyledList = styled.ul`
  margin-top: 6px;
  list-style-type: disc;
`;

const StyledListItem = styled.li`
  margin: 4px 0 0 16px;
  ${fontSize(12)};

  &:first-child {
    margin-top: 0;
  }
`;

const StyledQuantityWrapper = styled.div`
  display: flex;
  gap: 15px;
  justify-content: space-between;
  align-items: center;
  margin-top: 15px;
`;

const StyledRemove = styled.button`
  padding: 0;
  ${fontSize(14)};
  text-decoration: underline;
  background: none;
  border: none;
`;

const CartItem = ({
  product: { id, title, quantity: cartQuantity, variant, customAttributes },
}) => {
  const { updateProductInCheckout, removeProductFromCheckout } =
    useContext(StoreContext);
  const [quantity, setQuantity] = useState(cartQuantity);

  useEffect(() => {
    if (quantity !== cartQuantity) {
      updateProductInCheckout(id, quantity);
    }
  }, [quantity, cartQuantity, id, updateProductInCheckout]);

  let m2Pricing = false;
  let m2Quantity;

  customAttributes.find(attribute => {
    if (attribute.key === 'Width') {
      m2Pricing = true;
    }
    if (attribute.key === 'Qty') {
      m2Quantity = attribute.value;
    }
  });

  const imageData =
    variant &&
    variant.image &&
    getShopifyImage({
      image: { originalSrc: variant.image.src },
      layout: 'fixed',
      width: 70,
      height: 60,
    });

  return (
    <StyledCartItem>
      {imageData && (
        <GatsbyImage image={imageData} alt={variant.image.altText || title} />
      )}
      <StyledDetails>
        <StyledNamePrice>
          <StyledName>
            {title}
            {variant &&
              variant.title !== 'Default Title' &&
              ` (${variant.title})`}
            {m2Pricing ? ` × ${m2Quantity}` : ''}
          </StyledName>
          <StyledPrice>
            {variant && formatPrice(variant.price.amount * quantity)}
          </StyledPrice>
        </StyledNamePrice>
        {customAttributes.length > 0 && (
          <StyledList>
            {customAttributes.map(({ key, value }, id) => (
              <StyledListItem key={id}>
                {key}:{' '}
                {key === 'Graphic Design Price'
                  ? formatPrice(parseInt(value))
                  : value}
              </StyledListItem>
            ))}
          </StyledList>
        )}
        <StyledQuantityWrapper>
          <QuantityInput
            quantity={quantity}
            setQuantity={setQuantity}
            increment={1}
            isCartItem={true}
          />
          <StyledRemove onClick={() => removeProductFromCheckout(id)}>
            Remove
          </StyledRemove>
        </StyledQuantityWrapper>
      </StyledDetails>
    </StyledCartItem>
  );
};

export default CartItem;
